/* eslint-disable */
import $ from 'jquery';
import 'components/share';
import 'url-search-params-polyfill';
import MortgageUtils from './utils';
import Mediator from '../../common/scripts/observer';
import RangeSlider from 'components/range-slider';
import Utils from '../../common/scripts/utils';
import Html2Pdf from "components/html2pdf";

const html2pdf = new Html2Pdf();
const mediator = new Mediator();
const U = new MortgageUtils();

class Mortgage {
    /**
     * Метод иницализирует модуль
     * @param {Object} wrap - обертка модуля
     */
    init(wrap) {
        this._getElements(wrap);
        this._subscribes();
        this._initCalcSliders();
        this._bindEvents();
        this.setShareParam(false);
    }

    /**
     * Метод получает требуемые элементы
     * @param {Object} wrap - обертка модуля
     */
    _getElements(wrap) {
        this.$wrap = $(wrap);
        this.$sliders = this.$wrap.find('.j-range-slider');
        this.$table = this.$wrap.find('.j-mortgage-table');
        this.$title = this.$wrap.find('.mortgage__title');
        this.$cards = this.$wrap.find('.j-mortgage-cards');
        this.$tableItems = this.$table.find('tbody tr');
        this.$cardsItems = this.$cards.find('.j-mortgage-card');
        this.itemsArray = [this.$tableItems, this.$cardsItems];

        this.anchorText = $(document).find('.j-anchor-tab-active').find('.link__text');

        this.banksSelector = this.$wrap.find('tbody > tr');
        this.selectors = [this.banksSelector];

        this.$creditAmount = this.$wrap.find('.j-mortgage-credit-summ');
        this.$creditPercent = this.$wrap.find('.j-mortgage-slider__percent');
        this.$orderCount = this.$wrap.find('.j-mortgage-orders-count');
        this.$emptyResult = this.$wrap.find('.j-mortgage-empty');
        this.$emptyResultMobile = this.$wrap.find('.j-mortgage-empty-mobile');
        this.$buttonListMobile = this.$wrap.find('.j-mortgage-mobile-button');
        this.$pdfLink = this.$wrap.find('.j-mortgage-pdf-link');
        this.$shareInput = this.$wrap.find('.j-mortgage-share-email');
        this.$contentWrap = this.$wrap.find('.mortgage-content-wrap');
        this.$bestContainer = this.$wrap.find('.j-mortgage-best-offer');
        this.activeClass = 'is-active';
        this.disabledClass = 'is-disabled';
        this.hiddenClass = 'is-hidden';
    }

    /**
     * Инициализайия слайдеров ипотечного калькулятора
     * @private
     */
    _initCalcSliders() {
        const rangeSliderSelectors = Array.from(this.$sliders);

        if (rangeSliderSelectors.length) {
            rangeSliderSelectors.forEach((rangeSliderSelector, i) => {
                Mortgage.initSlider(rangeSliderSelector, i);
            });
        }
    }

    static initSlider(slider) {
        const rangeSlider = new RangeSlider();

        rangeSlider.init({wrapper: slider});
    };

    _bindEvents() {
        /*this.$pdfLink.on('click', (event) => {
            event.preventDefault();
            Mortgage.createPdfGet(event);
        });*/

        $(document).on('click', '.j-mortgage-reset', (event) => {
            event.preventDefault();

            this._resetData();
        });

        this.loadMoreProgramm();
        this.bestOffer();

        this.$buttonListMobile.on('click', (event) => {
            event.preventDefault();

            this.$contentWrap.toggleClass(this.hiddenClass);
        });
    }
    /**
     * Метод содержит в себе колбэки на событиях других модулей
     * @private
     */
    _subscribes() {
        this.show();

        mediator.subscribe('rangesliderStart', (data, rangeSlider) => {
            data.$input = data.input.closest('.j-range-slider').find('.range-slider__input');
            data.$postfix = data.input.closest('.j-range-slider').find('.range-slider__input-label_right_side');
            data.$rangeSlider = rangeSlider;
            this.updateSlidersValues(data, null);
            this.manualInput(data, this);
            this.update();
        });

        mediator.subscribe('rangesliderChange', (data) => {
            this.updateSlidersValues(data, 'set');
            this.update();
        });

        mediator.subscribe('rangesliderFinish', () => {
            this.setCredit();
            this.setShareParam();
            this.setCreditText();
        });
    }

    _resetData() {
        mediator.publish('paramfilterReset');

        this.update();

        window.history.pushState(null, null, window.location.pathname);
    }

    /**
     * Обновление значений экземпляра слайдера и запись в хранилище сессии при необходимости
     * @param {Object} data - данные слайдеров
     * @param {String/Null} flag - флаг, показывающий, нужно ли записывать данные слайдеров в хранилище сессии
     */
    updateSlidersValues(data, flag = null) {
        this.updateData(data, flag); //todo проверить зис
        Mortgage.setInput(data.from, data);
        this.setCredit();
    }

    /**
     * Считываем из хранилища или записываем в хранилище данные о текущем положении ползунков
     * @param {Object} data - все значения слайдера
     * @param {String} flag - флаг, указывающий, что данные нужно записать в хранилище
     */
    updateData(data, flag) {
        const key = U.getObjectData(data).key;
        const isDisabled = data.$input.prop('disabled');

        if (parseInt(Utils.getUrlParams(key)) && flag !== 'set' && !isDisabled) {
            data.from = parseInt(Utils.getUrlParams(key));
            U.accessStorage(key, data.from);
            console.log(1);
        } else if (U.isExist(U.accessStorage(key, null)) && flag !== 'set' && !isDisabled) {
            data.from = parseInt(data.from);
            U.accessStorage(key, data.from);
        } else {
            data.from = parseInt(data.from);
            U.accessStorage(key, data.from);
        }
    }

    /**
     * Записываем в инпуты значения слайдеров.
     * Добавляем разрядные пробелы и постфикс для срока кредита
     * @param {Object} value - значение слайдера
     * @param {Object} data - параметры слайдера
     */
    static setInput(value, data) {
        data.$input.val(value.toLocaleString('ru-Ru'));

        if (data.$input.attr('name') === 'limitation[min]') {
            data.$postfix.text(U.decodePostfix(value));
        }
    }

    /**
     * Выводим сумму и процент кредита
     * Если процент больше 100, выделяем его красным, а сумму кредита не выводим
     */
    setCredit() {
        this.$creditAmount.text(U.calcCredit().amount);
        this.$creditPercent.text(U.calcCredit().percent);

        if (parseInt(U.calcCredit().percent) >= 90) {
            $(this.$creditPercent).addClass('error');
        } else {
            $(this.$creditPercent).removeClass('error');
        }
    }

    /**
     * Выводим сумму и процент кредита
     * Если процент больше 100, выделяем его красным, а сумму кредита не выводим
     */
    setCreditText() {
        if (!this.anchorText.length) {
            return
        }
        this.anchorText.text(this.selectors[0].find('.j-mortgage-payment').first().text());
    }

    /**
     * Метод для непосредственного взаимодействия с инпутами (без использования слайдеров)
     * @param {Object} data - все значения слайдера
     * @param {Object} obj - экземпляр HTB для текущего инпута
     */
    manualInput(data, obj) {
        this.chooseInputInteraction(data, obj, 'focus');
        this.chooseInputInteraction(data, obj, 'blur');
        this.chooseInputInteraction(data, obj, 'keyup');
        this.chooseInputInteraction(data, obj, 'keydown');
    }

    /**
     * Определение поведения инпутов и слайдеров при взаимодействии с инпутами
     * @param {Object} data - все значения слайдера
     * @param {Object} obj - экземпляр HTB для текущего инпута
     * @param {String} interaction - тип взаимодействия с инпутом
     */
    chooseInputInteraction(data, obj, interaction) {
        let onlyNumbersRegexp = /[^0-9.]/g;
        const that = this;

        data.$input.on(interaction, function(e) {
            switch (interaction) {
                case 'focus':
                    U.use$Value(this, '');
                    break;
                case 'blur':
                    if (U.use$Value(this) === '') {
                        Mortgage.setInput(data.from, data);
                    } else {
                        U.checkInputedData(this, data, onlyNumbersRegexp);
                        that.updateSlidersValues(data, 'set');
                        data.$rangeSlider.slider.update();
                        that.update();
                    }
                    break;
                case 'keyup':
                    if (U.use$Value(this)) {
                        Mortgage.setInput(+(U.use$Value(this).replace(onlyNumbersRegexp, '')), data);
                    }
                    break;
                case 'keydown':
                    U.preventNaNSymbolsEnter(e);
                    U.onKeyDownEvent(e, data, obj, this, onlyNumbersRegexp);
                    break;
                default: console.error('Wrong type of interaction');
            }
        });
    }

    /**
     * Расчитываем ежемесячных платёж по формуле:
     * @param {Number} rate - ставка
     * @return {Number} - ежемесячный платёж
     * A = K * S,
     * где A - ежемесечный аннуитетный платёж,
     * K - коэффициент аннуитета,
     * S - сумма кредита.
     * K = (i * (1 + n)^n) / (((1 + i)^n) - 1)
     * i - месячная процентная ставка по кредиту (годовая/12)
     * n - количетсво периодов, в течение которых выплачивается кредит
     */
    static calcMonthlyPay(rate) {
        const i = rate / 12 / 100;
        const n = U.accessStorage('limitation[min]') * 12;
        const kNumerator = i * Math.pow(1 + i, n);
        const kDenominator = Math.pow(1 + i, n) - 1;
        const _K = kNumerator / kDenominator;
        const _S = U.accessStorage('creditAmount');
        const _A = _K * _S;

        return _A < 0 ? '—' : _A;
    }

    /**
     * Высчитываем и устанавливаем ежемесячный платёж каждому банку
     */
    setPaymentOnTable() {
        this.itemsArray.forEach((item) =>  {
            for (let i = 0; i < item.length; i++) {
                Mortgage.calcPaymentForBank($(item[i]));
                Mortgage.setFirstPayResult($(item[i]));
            }
        });
    }

    static calcPaymentForBank(item) {
        let rate = +item.find('.j-mortgage-rate').attr('data-rate');

        let monthlyPayment = U.isExist(Mortgage.calcMonthlyPay(rate)) ?
            U.calc('monthlyPaymentPretty', Mortgage.calcMonthlyPay(rate), null) : '—';
        item.find('.j-mortgage-payment').text(monthlyPayment);
    }

    static setFirstPayResult(item) {
        let pay = +item.find('.j-mortgage-first-payment').attr('data-firstPayment');
        let price = U.accessStorage('price[min]', null);

        let firstPayment = U.calc('monthlyPaymentPretty', (price * pay / 100));
        item.find('.j-mortgage-first-payment-val').text(firstPayment);
    }

    /**
     * Передаём список банков на проверку соответствия условиям
     * @private
     */
    _disableItems() {
        this.itemsArray.forEach((item) =>  {
            for (let i = 0; i < item.length; i++) {
                this._setDisabled($(item[i]));
            }
        });
    }

    /**
     * Отключаем банк, если он не подходит по параметрам
     * @param {Object} item - DOM элемент каждого банка (строка в таблице или карточка)
     * @private
     */
    _setDisabled(item) {
        let firstPaymentCell  = item.find('.j-mortgage-first-payment');
        let limitationCell    = item.find('.j-mortgage-limitation');
        let monthlyPayment    = item.find('.j-mortgage-payment');
        let firstPayment      = +firstPaymentCell.attr('data-firstPayment');
        let firstPaymentMax   = +firstPaymentCell.attr('data-firstPaymentMax');
        let limitation        = +limitationCell.attr('data-limitation');
        let limitationMin     = +limitationCell.attr('data-limitationMin');
        let creditSummMax     = +item.attr('data-creditAmountMax');
        let creditSummMin     = +item.attr('data-creditAmountMin');

        if (U.accessStorage('creditPercent') < firstPayment    ||
            U.accessStorage('creditPercent') > firstPaymentMax ||
            U.accessStorage('limitation[min]') > limitation    ||
            U.accessStorage('limitation[min]') < limitationMin ||
            U.accessStorage('creditAmount')  < creditSummMin   ||
            U.accessStorage('creditAmount')  > creditSummMax) {
            monthlyPayment.text('—');
            item.addClass(this.disabledClass);
        } else {
            item.removeClass(this.disabledClass);
        }
    }

    /**
     * Устанавливает кол-во подходящих программ
     * @private
     */
    _setOrdersCount() {
        const count = this.$tableItems.not('.is-disabled').length;
        const countWord = Utils.pluralWord(count, ['предложение', 'предложения', 'предложений']);
        this.$orderCount.text(`${count} ${countWord}`);
    }

    /**
     * Выводит плашку об отсутствии результатов
     * @private
     */
    _checkEmptyResult() {
        const method = !this.$tableItems.not('.is-disabled').length ? 'addClass' : 'removeClass';

        this.$emptyResult[method](this.activeClass);
        this.$emptyResultMobile[method](this.activeClass);
        this.$buttonListMobile[method](this.disabledClass);
        this.$table[method](this.activeClass);
        this.$title[method](this.activeClass);
        this.$pdfLink[method](this.disabledClass);

        if (window.matchMedia('(max-width: 959px)').matches) {
            this.$contentWrap.addClass(this.hiddenClass);
            this.$bestContainer[method](this.hiddenClass);
        }
    }

    /**
     * Передаём строки таблицы с банками на упорядочивание
     */
    _setTableOrder() {
        for (let i = 0; i < this.$tableItems.length; i++) {
            this._setItemOrder($(this.$tableItems[i]));
        }
    }

    /**
     * Передаём карточки с банками на упорядочивание
     * @private
     */
    _setCardsOrder() {
        for (let i = 0; i < this.$cardsItems.length; i++) {
            this._setItemOrder($(this.$cardsItems[i]));
        }
    }

    /**
     * Устанавливаем свойство order для каждого банка, чтобы упорядочить элементы по цене
     * @param {Object} obj - DOM элемент каждого банка (строка в таблице или карточка)
     * @private
     */
    _setItemOrder(obj) {
        const specialOrderCoefficient = 10000000;
        let payment = +obj.find('.j-mortgage-payment').text().replace(/[^0-9]/g, '');
        obj.attr('data-payment', (payment === 0) ? specialOrderCoefficient : payment);

        if (obj.attr('data-sort') && !obj.hasClass(this.disabledClass)) {
            payment = +obj.data('sort');
        }

        obj.css('order', (payment === 0) ? specialOrderCoefficient : payment);
    }

    /**
     * Сортировка таблицы банков
     * @param {String} rowSelector - селектор для банков.
     * Разделяет порядок сортировки специальных и обычных банков
     * @private
     */
    _sortTable(rowSelector) {
        let $rows = $(rowSelector, this.$table).toArray();

        $rows = this.mergeSort($rows);

        $rows.forEach((row) => {
            this.$table.append(row);
        });
    }

    /**
     * Алгоритм MergeSort. Почти во всех браузерах используется по умолчанию,
     * однако google chrome использует данный алгоритм исключительно когда элементов для сортировки меньше 10
     * если элементов больше, что chrome начинает использовать QuickSort.
     * QuickSort значительно быстрее, нежели MergeSort, однако, в отличии от MergeSort, является нестабильным
     * (Unstable Algorithm, сортировка происходит без сохранения индексации элементов).
     * Из-за отсутствии индексации элементы с одинаковыми значениями хаотично меняются местами при сортировке.
     * WARNING! Не отключайте MergeSort для гугла, пожалейте эпилептиков
     * @param {Array} rows - массив строк таблицы банков
     * @return {Array} - смерженный массив
     */
    mergeSort(rows) {
        if (rows.length <= 1) {
            return rows;
        }

        const middle = Math.floor(rows.length / 2);
        const left = rows.slice(0, middle);
        const right = rows.slice(middle, rows.length);

        return Mortgage.merge(this.mergeSort(left), this.mergeSort(right));
    }

    /**
     * Вспомогательная функция для алгоритма MergeSort
     * @param {Array} left - массив для слияния
     * @param {Array} right - массив для слияния
     * @return {Array} - отсортированный массив
     */
    static merge(left, right) {
        let result = [];

        while (left.length && right.length) {
            if (Mortgage.mergeSortFunction(left[0], right[0]) < 1) {
                result.push(left.shift());
            } else {
                result.push(right.shift());
            }
        }

        while (left.length) {
            result.push(left.shift());
        }

        while (right.length) {
            result.push(right.shift());
        }

        return result;
    }

    /**
     * Вспомогательная функция для алгоритма MergeSort.
     * @param {Object} a - объект сортировки
     * @param {Object} b - объект сортировки
     * @return {Number} - число, знак которого определяет местоположние элемента при сортировке
     */
    static mergeSortFunction(a, b) {
        return +$(a).css('order') - (+$(b).css('order'));
    }

    /**
     * Функция обновления значений ипотечной таблицы, карточек и количества предложений
     */
    update() {
        this.setPaymentOnTable();
        this._disableItems();
        this._setOrdersCount();
        this._checkEmptyResult();
        this._setTableOrder();
        this._setCardsOrder();
        this.selectors.forEach((selector) => {
            this._sortTable(selector);
        });

        this.loadMoreProgramm();
        this.bestOffer();
    }

    /**
     * Показывает компонент после всех расчетов.
     */
    show() {
        this.$wrap.addClass('is-ready');
    }

    /**
     * Заполняем все скрытые поля формы "Лучшее предложение" для отправки на сервер
     */
    setMortgageRequest() {
        let $hiddenInputs = $('.j-mortgage-request input');

        let valuesArray = [
            U.accessStorage('best-offer-id', null),
            U.accessStorage('price[min]', null),
            U.accessStorage('first-pay[min]', null),
            U.accessStorage('limitation[min]', null),
            U.accessStorage('best-offer-monthly', null)
        ];

        $hiddenInputs.each((i, item) => {
            $(item).val(valuesArray[i]);
        });
    }

    static createPdfGet(event) {
        const target = event.currentTarget;
        const id = target.getAttribute('data-id');
        const ajax = target.getAttribute('data-ajax');
        const fileName = target.getAttribute('data-file');

        const printButton = document.createElement('button');
        printButton.style.display = 'none';
        printButton.classList.add('j-print-mortgage');
        printButton.dataset.ajax = ajax;
        printButton.dataset.file = fileName;
        printButton.dataset.id = id;
        printButton.dataset.calcPriceMean = U.accessStorage('price[min]');
        printButton.dataset.calcFirstPaymentPercent = U.accessStorage('first-pay[min]');
        printButton.dataset.calcPeriodMean = U.accessStorage('limitation[min]');

        document.body.appendChild(printButton);

        html2pdf.init({
            targets    : Array.from(document.querySelectorAll('.j-print-mortgage')),
            autoload   : true,
            orientation: 'portrait',
            quality    : 5,
            pageBreak  : '.pdf__container'
        });

        printButton.click();
        document.body.removeChild(printButton);
    }

    setShareParam(setHash = true) {
        const query = new URLSearchParams();
        const hash = window.location.hash;

        query.append('price[min]', U.accessStorage('price[min]'));
        query.append('first-pay[min]', U.accessStorage('first-pay[min]'));
        query.append('limitation[min]', U.accessStorage('limitation[min]'));

        if (setHash) {
            window.history.pushState(null, null, `?${query.toString()}${hash}`);
            this.$shareInput.val(window.location.href);
        }

        if (this.$pdfLink) {
            const separate = (this.$pdfLink.attr('href') && this.$pdfLink.attr('href').match(/\?./)) ? '&' : '?';
            this.$pdfLink.attr('href', `${this.$pdfLink.attr('href')}${separate}${query.toString()}`);
        }
    }

    bestOffer() {
        const $container = this.$bestContainer;
        const $month = $container.find('.best-monthly');
        const $summ = $container.find('.best-summ');
        const $percent = $container.find('.best-percent');
        const $special = $('tbody .j-mortgage-table__row').first();
        let arr = [];

        $month.text($special.find('.j-mortgage-payment').text().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '));
        $summ.text(U.calcCredit().amount);
        $percent.text($special.find('.j-mortgage-rate').text());
    }

    loadMoreProgramm() {
        const that = this;
        const $button = this.$wrap.find('.j-mortgage-loadmore');
        const $buttonWrapp = $button.closest('.mortgage-loadmore');
        const $counter = $button.find('.mortgage-loadmore__counter');
        let $dataShow = $button.attr('data-show');
        let $allCards = this.$cardsItems;
        let $showedCard = $allCards.not(`.${that.hiddenClass}`);
        let $allRowBank = $('tbody .j-mortgage-table__row');
        let $showedRowBank = $allRowBank.not(`.${that.hiddenClass}`);

        let counterBanks = () => {
            if (window.matchMedia('(max-width: 959px)').matches) {
                $allCards.addClass(that.hiddenClass);
                $allCards.slice(0, $dataShow).removeClass(that.hiddenClass);
                let title = U.declOfNum($allCards.length - $showedCard.length, ['ипотечную программы', 'ипотечных программ', 'ипотечные программы']);
                $counter.text(`Показать все`);

                if ($allCards.length > $dataShow) {
                    $buttonWrapp.show();
                }
            } else {
                $allRowBank.addClass(that.hiddenClass);
                $allRowBank.slice(0, $dataShow).removeClass(that.hiddenClass);
                let title = U.declOfNum($allRowBank.length - $showedRowBank.length, ['ипотечную программу', 'ипотечных программы', 'ипотечные программы']);
                $counter.text(`Показать все`);

                if ($allRowBank.length > $dataShow) {
                    $buttonWrapp.show();
                }
            }
        };

        counterBanks();

        $(window).resize(function() {
            counterBanks();
        });
        $button.unbind();
        $button.on('click', function(event) {
            event.preventDefault();
            $(this).toggleClass(that.activeClass);

            if (!$(this).hasClass(that.activeClass)) {
                counterBanks();
            } else {
                if (window.matchMedia('(max-width: 959px)').matches) {
                    $allCards.removeClass(that.hiddenClass);
                } else {
                    $allRowBank.removeClass(that.hiddenClass);
                }

                $counter.text('Свернуть список');
            }
        });
    }

}

export default Mortgage;
/* eslint-enable */
